import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import Button from "../../../components/button";
import Input from "../../../components/input";
import { useSelector } from "react-redux";
import { updateConfiguration } from "../../../api/endpoint"
import Loader from "../../../components/loader";
import toast from "react-hot-toast";
import axios from "axios";

const UpdateEmailModal = ({ isUpdateOpen, closeUpdateModal, fetchConfig }) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { config } = useSelector((state) => state.config);
  const { auth } = useSelector((state) => state.login);

  useEffect(() => {
    setEmail(config?.contactInfo?.email);
  }, [config]);

  const updateConfig = async (e) => {
    e.preventDefault();
    if (!email) {
      setError("Email Required");
      return;
    } else if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) == false) {
      setError("Please enter a valid email");
      return;
    }

    const newConfig = {
      ...config,
      contactInfo: {
        ...config?.contactInfo,
        email: email,
      },
    };
    try {
      setLoading(true);
      const response = await axios.post(updateConfiguration, newConfig, {
        headers: { Authorization: `Bearer ${auth}` },
      });
      toast.success("Email Updated Successfully");
      closeUpdateModal();
      fetchConfig();
    } catch (error) {
      toast.error("Error Updating Contact Email");
      console.error("Error Updating Contact Email", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <Modal show={isUpdateOpen} onHide={closeUpdateModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Update Contact Email</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Input
            type="email"
            label="Email"
            placeholder="Enter Contact Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {error && <div className="text-danger">{error}</div>}
        </Modal.Body>
        <Modal.Footer>
          <Button text="Save Changes" callBack={updateConfig} />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UpdateEmailModal;
